<template>
  <nav class="mobile-tab-bar" aria-label="Primary">
    <router-link
      class="mobile-tab-bar__tab"
      :class="{ 'is-active': isLibraryActive }"
      :to="libraryTarget"
      @click="trackTab('library')"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path d="M4 6h16M4 12h16M4 18h10" />
      </svg>
      <span>Library</span>
    </router-link>
    <!-- Real-time recording is behind the same PostHog flag as the desktop
         Record button; without it the center action is Import. -->
    <button
      class="mobile-tab-bar__record"
      type="button"
      :aria-label="centerAction.label"
      @click="centerAction.run"
    >
      <span class="mobile-tab-bar__record-fab">
        <IconMic v-if="recordingEnabled" />
        <IconImport v-else />
      </span>
      <span class="mobile-tab-bar__record-label">{{ centerAction.label }}</span>
    </button>
    <router-link
      class="mobile-tab-bar__tab"
      :class="{ 'is-active': $route.name === 'account' }"
      :to="{ name: 'account' }"
      @click="trackTab('account')"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
      </svg>
      <span>Account</span>
    </router-link>
  </nav>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { useWorkSpaceStore } from "@/stores/workspace-store";
import { mapStores } from "pinia";
import { analytics, isRecordingEnabled } from "@/services/analytics.service";
import { libraryRoute } from "@/utils/navigation";
import IconMic from "./icons/IconMic.vue";
import IconImport from "./icons/IconImport.vue";

export default {
  name: "MobileTabBar",
  components: { IconMic, IconImport },
  computed: {
    ...mapStores(useAppStore),
    ...mapStores(useWorkSpaceStore),
    libraryTarget() {
      return libraryRoute(this.$route, this.workspaceStore);
    },
    isLibraryActive() {
      return this.$route.meta?.shellTab === "library";
    },
    recordingEnabled() {
      return isRecordingEnabled();
    },
    centerAction() {
      return this.recordingEnabled
        ? { label: "Record", run: this.openRecordSheet }
        : { label: "Import", run: this.openImport };
    },
    currentShellTab() {
      return this.$route.meta?.shellTab || this.$route.name;
    },
  },
  watch: {
    currentShellTab: {
      immediate: true,
      handler(tab) {
        analytics.mobileShellViewed({ tab });
      },
    },
  },
  methods: {
    trackTab(tab) {
      analytics.mobileTabClicked({ tab });
    },
    openRecordSheet() {
      analytics.mobileTabClicked({ tab: "record" });
      this.appStore.showMobileRecordSheet = true;
    },
    openImport() {
      analytics.mobileTabClicked({ tab: "import" });
      this.appStore.openImportPopup();
    },
  },
};
</script>
